import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchAdGroupCopyHistory,
  reset,
  retryAdGroupCopy,
  setPage,
} from 'features/bulk/adGroupCopy/adGroupCopyHistorySlice'
import Button from 'components/form/Button'
import Table from 'components/table/Table'
import Pagination from 'components/pagination/Pagination'
import Moment from 'react-moment'
import Tooltip from 'components/tooltip/Tooltip'
import { fail } from 'features/toast/Toast'
import { dateformat } from 'utils'

const COPY_STATUS = {
  IN_PROGRESS: '작업중',
  FINISHED: '완료',
  KEYWORD_COPY_FAILED: '일시정지',
  CREATIVE_LINK_COPY_FAILED: '일시정지',
}

const AdGroupCopyHistory = () => {
  const dispatch = useDispatch()
  const {
    isLoading,
    content,
    totalElements,
    page,
    size,
    error,
    disabledRetry,
  } = useSelector(state => state.bulk.adGroupCopy)

  useEffect(() => {
    dispatch(fetchAdGroupCopyHistory())
  }, [dispatch, page])

  useEffect(
    () => () => {
      dispatch(reset())
    },
    [dispatch]
  )

  const handleRefresh = () => {
    dispatch(fetchAdGroupCopyHistory())
  }

  const handleRetry = async id => {
    const { error: retryError, payload } = await dispatch(retryAdGroupCopy(id))
    if (retryError) {
      fail(payload.errorMessage)
    } else {
      dispatch(fetchAdGroupCopyHistory())
    }
  }
  const handlePageChange = v => dispatch(setPage(v))
  return (
    <>
      <ul className="list_append">
        <li>
          광고그룹 복사 메뉴를 통해 복사 요청한 그룹의 복사 완료 여부를 확인하실
          수 있습니다.
        </li>
        <li>
          대량 관리를 통한 작업 시간은 사용량과 데이터 크기에 따라 유동적일 수
          있으며, 대량 관리 내역은 최근 3개월까지만 제공합니다.
        </li>
      </ul>
      <div className="ad_managebox">
        <div className="managebox_tit">
          <strong className="tit_box">
            총 복사 목록 <em className="fc_emph">{totalElements}</em>
          </strong>
          <div className="f_right">
            <Button line onClick={handleRefresh} disabled={isLoading}>
              새로고침
            </Button>
          </div>
        </div>
        <div className="tblg2_wrap">
          <Table
            className="tbl_g2"
            caption="광고그룹 복사 목록 표"
            loading={isLoading}
            emptyMessage="광고그룹 복사 이력이 없습니다."
            error={error}
            errorMessage="일시적인 문제로 광고그룹 복사 이력을 불러올 수 없습니다.">
            <Table.Head>
              <Table.Column title="등록일시" width={154} />
              <Table.Column title="복사선택 광고그룹" width={243} />
              <Table.Column title="복사완료 광고그룹" width={243} />
              <Table.Column title="처리자" />
              <Table.Column title="상태" width={152} />
              <Table.Column title="완료일시" width={135} />
            </Table.Head>
            <Table.Body>
              {content.map(
                ({
                  id,
                  originalId,
                  createdDate,
                  sourceCampaignName,
                  sourceAdGroupName,
                  targetCampaignName,
                  targetAdGroupName,
                  kakaoEmail,
                  status,
                  updatedDate,
                }) => (
                  <Table.Row
                    key={`${id}_${originalId}`}
                    rowId={`${id}_${originalId}`}>
                    <td>
                      <div className="inner_tbl">
                        <Moment format={dateformat}>{createdDate}</Moment>
                      </div>
                    </td>
                    <td>
                      <div className="inner_tbl">
                        {sourceCampaignName} &gt; {sourceAdGroupName}
                      </div>
                    </td>
                    <td>
                      <div className="inner_tbl">
                        {targetCampaignName} &gt; {targetAdGroupName}
                      </div>
                    </td>
                    <td>
                      <div className="inner_tbl">{kakaoEmail}</div>
                    </td>
                    <td>
                      <div className="inner_tbl">
                        <p className="ad_state">
                          {['IN_PROGRESS', 'FINISHED'].includes(status) ? (
                            <>
                              <span className="ico_on">on</span>
                              {COPY_STATUS[status]}
                            </>
                          ) : (
                            <>
                              <Tooltip
                                position="bottom"
                                content={
                                  <>
                                    그룹복사 진행 중 작업이 일시중지 되었습니다.
                                    <br />
                                    재진행을 눌러 남아 있는 복사를 진행해
                                    주세요.
                                  </>
                                }>
                                <span className="ico_off">off</span>
                                {COPY_STATUS[status]}
                              </Tooltip>
                              <Button
                                line
                                size="small"
                                onClick={() => handleRetry(id)}
                                disabled={disabledRetry}>
                                재진행
                              </Button>
                            </>
                          )}
                        </p>
                      </div>
                    </td>
                    <td>
                      <div className="inner_tbl">
                        {updatedDate && (
                          <Moment format={dateformat}>{updatedDate}</Moment>
                        )}
                      </div>
                    </td>
                  </Table.Row>
                )
              )}
            </Table.Body>
          </Table>
        </div>
        {totalElements > 0 && (
          <div className="paging_wrap">
            <div className="inner_paging">
              <Pagination
                current={page}
                total={totalElements}
                size={size}
                onChange={handlePageChange}
              />
            </div>
          </div>
        )}
      </div>
    </>
  )
}
export default AdGroupCopyHistory
